import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded";
import { Box, Typography } from "@mui/material";
import { useState } from "react";
import useColors from "../../../../api/hooks/useColors";
import CustomToolTip from "../../../../components/CustomTooltip";
import { LATEST } from "../../../../utils/constants";
import { getCoverageColor, getRiskColor } from "../utils";

const PracticeItem = ({
  practice,
  setSelectedPractice,
  showRisk,
  selectedTimePoint,
}) => {
  const colors = useColors();
  const [isHovered, setIsHovered] = useState(false);
  const isDisabled = practice.controls.length === 0;
  return (
    <Box>
      <CustomToolTip
        title={
          isDisabled
            ? "There are no controls in place for this security practice."
            : ""
        }
        placement="top"
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            padding: "8px 6px",
            borderRadius: 1,
            transition: "all 0.2s ease",
            cursor:
              isDisabled || selectedTimePoint !== LATEST
                ? "default"
                : "pointer",
            justifyContent: "space-between",
            backgroundColor: isHovered ? colors.grey_5percent : "transparent",
          }}
          onMouseEnter={() =>
            selectedTimePoint === LATEST && setIsHovered(true)
          }
          onMouseLeave={() =>
            selectedTimePoint === LATEST && setIsHovered(false)
          }
          onClick={() => !isDisabled && setSelectedPractice(practice)}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              gap: 2,
              alignItems: "center",
            }}
          >
            <Box
              sx={{
                width: "4px",
                height: "16px",
                borderRadius: "2px",
                padding: "2px",
                backgroundColor: showRisk
                  ? getRiskColor(practice.severity, colors)
                  : getCoverageColor(practice.severity, colors),
                transition: "transform 0.2s ease",
                transform: isHovered ? "scale(1.2)" : "scale(1)",
              }}
            />
            <Typography
              variant="body2"
              sx={{
                color: isHovered ? colors.text_primary : colors.text_secondary,
                fontWeight: 400,
                transition: "all 0.2s ease",
              }}
            >
              {practice.name}
            </Typography>
          </Box>
          {isHovered && !isDisabled && (
            <ArrowForwardIosRoundedIcon
              sx={{
                width: "10px",
                height: "10px",
              }}
            />
          )}
        </Box>
      </CustomToolTip>
    </Box>
  );
};

export default PracticeItem;
